import DialogShell from "./DialogShell";

export default function ConfirmDialog({ open, title = "Confirmar a exclusão?", description, confirmLabel = "Confirmar", cancelLabel = "Cancelar", busy = false, onCancel, onConfirm }) {
  if (!open) return null;

  return (
    <DialogShell className="admin-dialog--notice" role="alertdialog" labelledBy="admin-confirm-title" onClose={busy ? undefined : onCancel}>
      <button type="button" className="admin-dialog__close" aria-label="Fechar" onClick={onCancel} disabled={busy}>&times;</button>
      <h2 id="admin-confirm-title" className="admin-dialog__notice-title">{title}</h2>
      {description && <p className="admin-dialog__description">{description}</p>}
      <div className="admin-dialog__notice-actions">
        <button type="button" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
        <button type="button" onClick={onConfirm} disabled={busy}>{busy ? "Aguarde..." : confirmLabel}</button>
      </div>
    </DialogShell>
  );
}
